const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  content: {
    maxWidth: "600px",
    margin: "0 auto",
    padding: "20px",
    width: "100%",
  },
  contentLg: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
    width: "100%",
  },
  contentXl: {
    maxWidth: "1760px",
    margin: "0 auto",
    padding: "20px",
    width: "100%",
  },
  contentFull: {
    maxWidth: "100%",
    margin: 0,
    padding: "4px 8px 8px",
    width: "100%",
  },
  header: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    padding: "0px 30px",
    background: "var(--cc-bg, #F6F5F2)",
  },
  // Opt-in full-bleed zen cream backdrop (matches the care-plan pages).
  // 56px = sticky UserHeader bar above the wrapper; without subtracting it the
  // document always scrolls past viewport-fitted pages.
  zenBackdrop: {
    background: "var(--cc-bg, #F6F5F2)",
    minHeight: "calc(100vh - 56px)",
  },
}));
